import React, { useEffect, useRef, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { Services } from '@/services/services';

import './Main.css'
import { Translates } from '@/services/repository/i18n';
import { MainPageLayout } from '@/components/layout/MainLayout';
import { Machine } from '@/services/model/machine';
import { CurrentSession } from '@/services/repository/session';
import { WizardData, LoadWizardData, SaveWizardData } from './Model';
import { BackButton } from '@/components/layout/NavBar';
import { FilesProvider, SimpleFiles } from '@/components/forms/common/files/files';
import { Stream } from '@/services/common/stream';
import * as osfiles from "@/components/forms/common/osfiles"

const API_BASE = "/api/public/tmp/files"

export const SupportWizardStep3 = ({ services, session }: { services: Services, session?: CurrentSession }) => {
  const navigate = useNavigate()
  const [translates, setTranslates] = useState<Translates>()
  const [wizardData, setWizardData] = useState<WizardData>(LoadWizardData())
  const statusStreamRef = useRef<Stream<osfiles.UploadStatus>>(new Stream<osfiles.UploadStatus>())

  useEffect(() => {
    if (session) {
      setTranslates(session.translates)
      return
    }
    services.i18n.get('main').then(setTranslates)
  }, [session])

  if (translates === undefined || wizardData === undefined) {
    return <div className='spinner'></div>
  }

  return <MainPageLayout pageName='support-wizard' services={services} translates={translates} session={session}
        navbarLeft={
          <BackButton
            services={services}
            translates={translates}
            replaceUrl={`/communal/support/wizard/page2`}
          />
        }>

    <h2 className='page-title'>{translates.for(`wizards.support_question.title`)}</h2>

    <FilesProvider insertUrl={`${API_BASE}/new`} updateUrl={`${API_BASE}/{id}/upload`} fetchUrl={`${API_BASE}/{id}/list`} removeUrl={`${API_BASE}/{id}/remove/{fid}`} token={session?.token} translates={translates} filesId={wizardData.setId} statusStream={statusStreamRef.current}
      onChange={(id: string) => setWizardData((prev) => {
        if (!prev) return prev;
        const updated: WizardData = { ...prev, setId: id }
        SaveWizardData(updated)
        return updated
      })}>
      <SimpleFiles />
    </FilesProvider>

    <div className='approve-btn' onClick={() => {
      SaveWizardData(wizardData)
      navigate(`/communal/support/wizard/page4`, { replace: true })
    }}>
      {translates.for(`wizards.support_question.next`)}
    </div>

  </MainPageLayout>
}
